import { render, staticRenderFns } from "./ShopEdit.vue?vue&type=template&id=6d755720"
import script from "./ShopEdit.vue?vue&type=script&lang=js"
export * from "./ShopEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports